import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Input,
  Button,
  FormText,
} from "reactstrap";

import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { signUp } from "../../store/actions/authActions";

class SignUp extends Component {
  state = {
    unit: "",
    email: "",
    password: "",
    defaultModal: false,
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.signUp(this.state);
    this.setState({
      defaultModal: true,
    });
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };

  render() {
    const { authError, signUpSuccess } = this.props;

    return (
      <>
        <div>
          {this.props.auth && this.props.profile.userType === "admin" ? ( <Card>
            <CardBody>
              <CardTitle>
                <h4 className="text-center">Sign Up</h4>
              </CardTitle>
              <Form onSubmit={this.handleSubmit}>
                <FormGroup>
                  <FormText>Unit</FormText>
                  <Input
                    required
                    type="select"
                    name="unit"
                    id="unit"
                    onChange={this.handleChange}
                  >
                    <option value="No Value">Select</option>
                    <option value="1 SLE">1 SLE</option>
                    <option value="2 SLE">2 SLE</option>
                    <option value="3 SLE">3 SLE</option>
                    <option value="4 SLE">4 SLE</option>
                    <option value="5 SLE">5 SLE</option>
                    <option value="6 SLE">6 SLE</option>
                    <option value="7 SLE">7 SLE</option>
                    <option value="8 SLE">8 SLE</option>
                    <option value="9 SLE">9 SLE</option>
                    <option value="10 SLE">10 SLE</option>
                    <option value="11 SLE">11 SLE</option>
                    <option value="12 SLE">12 SLE</option>
                    <option value="SLSME">SLSME</option>
                    <option value="WKSP">WKSP</option>
                  </Input>
                </FormGroup>

                <FormGroup>
                  <FormText>Email</FormText>
                  <Input
                    required
                    type="email"
                    name="email"
                    id="email"
                    placeholder="something@idk.cool"
                    onChange={this.handleChange}
                  />
                </FormGroup>

                <FormGroup>
                  <FormText>Password</FormText>
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    placeholder="password"
                    onChange={this.handleChange}
                  />
                  {/* <FormFeedback valid>
                        Sweet! that name is available
                      </FormFeedback>
                      <FormText>
                        Example help text that remains unchanged.
                      </FormText> */}
                </FormGroup>

                <FormGroup>
                  {authError ? (
                    <p className="text-danger">{authError}</p>
                  ) : null}
                </FormGroup>

                <FormGroup>
                  <Button color="primary" block>
                    Register
                  </Button>
                </FormGroup>
              </Form>
            </CardBody>
          </Card>):(null)}
         
          {signUpSuccess &&
          signUpSuccess === true &&
          this.state.defaultModal ? (
            <SweetAlert
              success
              title="Successfully Registered"
              showConfirm={false}
            >
              <p>You've to login again due to security reason</p>

              <Link to={"/"} className="navbar-brand">
                <Button
                  className="btn-icon btn-3"
                  color="primary"
                  type="button"
                >
                  Back to Home
                </Button>
              </Link>
            </SweetAlert>
          ) : null}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError,
    signUpSuccess: state.auth.signUpSuccess,
    profile: state.firebase.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signUp: (newUser) => dispatch(signUp(newUser)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
